import { useLang } from "@/lib/siteI18n";
import { LANGS } from "@/lib/diagnosticInauguralI18n";

export const LangSwitcher = ({ compact = false, id = "lang-switcher" }) => {
  const { lang, setLang, t } = useLang();
  return (
    <div className="flex items-center gap-1" role="group" aria-label={t.nav.langLabel} data-testid={id}>
      {LANGS.map((l) => (
        <button key={l} type="button" onClick={() => setLang(l)} data-testid={`${id}-${l}`} aria-pressed={lang === l}
          className={`${compact ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-1 text-[11px]"} uppercase tracking-[0.15em] border transition-colors ${
            lang === l ? "bg-gold text-brand-ink border-gold" : "text-white/50 border-white/15 hover:text-white hover:border-white/40"}`}>
          {l}
        </button>
      ))}
    </div>
  );
};
